export const PRICING_LOG_TYPE_MAP: Record<string, string> = {
  drush: "Subscription Emails",
  subscription_dashboard: "Rate Dashboard"
}
